import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

type ColorTheme = 'primary' | 'secondary';

@Component({
  selector: 'app-empty-state-placeholder',
  imports: [MatIcon],
  templateUrl: './empty-state-placeholder.component.html',
  styleUrl: './empty-state-placeholder.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStatePlaceholderComponent {
  icon = input<string>();
  heading = input<string>();
  message = input<string>();
  colorTheme = input<ColorTheme>('secondary');

  getIconClasses(): string {
    const theme = this.colorTheme();
    const colorMap = {
      primary: 'bg-primary-100 text-primary-700',
      secondary: 'bg-secondary-100 text-secondary-700',
    };
    return colorMap[theme] || colorMap.secondary;
  }
}
